<footer class="footer">
    <p class="footer__text">Desenvolvido por João Paulo Hotequil</p>
</footer>
